import React from 'react';
import { Menu } from 'lucide-react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b border-green-700" style={{
    backgroundColor: 'rgba(133, 187, 101, 0.95)'
  }} data-id="element-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="flex justify-between items-center h-20" data-id="element-38">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-39">
            <a href="/" className="flex items-center gap-3 text-2xl font-bold tracking-tighter text-slate-900" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/6JGUzALXbouXbu1nReuJHv/Twice_Bourne_Brand_Logo-07.svg" alt="Twice Bourne Logo" className="h-12 w-auto" data-id="element-41" />
              TWICE BOURNE
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-42">
            <a href="/#about" className="text-sm font-medium text-slate-900/80 hover:text-slate-900 transition-colors" data-id="element-43">
              About Us
            </a>
            <a href="/#brands" className="text-sm font-medium text-slate-900/80 hover:text-slate-900 transition-colors" data-id="element-44">
              Our Brands
            </a>
            <a href="/#contact" className="text-sm font-medium text-slate-900/80 hover:text-slate-900 transition-colors" data-id="element-45">
              Contact
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center" data-id="element-46">
            <button type="button" className="text-slate-900 hover:text-slate-700 p-2" aria-label="Open main menu" data-id="element-47">
              <Menu className="h-6 w-6" aria-hidden="true" data-id="element-48" />
            </button>
          </div>
        </div>
      </div>
    </header>;
}